var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconinfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2766",
    "data-name": "Grupo 2766",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2766-2",
    "data-name": "Grupo 2766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6259",
    "data-name": "Caminho 6259",
    d: "M754.5-49.5a9,9,0,0,0-9,9,9,9,0,0,0,9,9,9,9,0,0,0,9-9A9,9,0,0,0,754.5-49.5Zm-1.04,12.885v-4.12a1.04,1.04,0,0,1,1.04-1.04,1.04,1.04,0,0,1,1.04,1.04v4.12a1.04,1.04,0,0,1-1.04,1.04A1.04,1.04,0,0,1,753.46-36.615Zm1.04-6.295a1.25,1.25,0,0,1-1.25-1.25,1.25,1.25,0,0,1,1.25-1.25,1.25,1.25,0,0,1,1.25,1.25h0A1.25,1.25,0,0,1,754.5-42.91Z",
    transform: "translate(-745.5 49.5)",
    fill: "#005288"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconinfo);
export default __webpack_public_path__ + "static/media/icon info.1f88b907de318fe620fe79c0f463e887.svg";
export { ForwardRef as ReactComponent };